import { useMemo } from 'react';
import { useAuth } from '../context';
import { TypeUser } from '../types/enums';
import { useConfig } from '../context/configCustom';

type UserPlanStatus = {
  hasPlan: boolean;
  isExpired: boolean;
  expirationDate?: Date;
  rawStatus?: number;
  shouldRedirectToSubscribe: boolean;
};

export function useUserPlanStatus(): UserPlanStatus {
  const { user } = useAuth();
  const { pathResourceEmail } = useConfig();

  return useMemo(() => {
    const userPlan = user?.userPlan;
    const hasPlan = Boolean(userPlan && userPlan.planId);
    const expirationDate = userPlan?.expirationDate ? new Date(userPlan.expirationDate) : undefined;
    const now = new Date();

    // Fallback: consider status 2 (Expirated) if provided by backend
    const rawStatus = (userPlan as any)?.status as number | undefined;
    const statusSaysExpired = rawStatus === 2;
    const dateSaysExpired = expirationDate ? expirationDate.getTime() < now.getTime() : !hasPlan;
    const isExpired = statusSaysExpired || dateSaysExpired;

    const shouldRedirectToSubscribe = false;
    // user.type !== TypeUser.BASEUSER &&
    // pathResourceEmail !== 'TemplatesVigna' &&
    // (!hasPlan || (isExpired && user?.type !== TypeUser.ADM));
    return { hasPlan, isExpired, expirationDate, rawStatus, shouldRedirectToSubscribe };
  }, [user]);
}
